export const languages = [{ara: "arabic"},
{aze: "azerbaijani"},
{bos: "bosnian"},
{bul: "bulgarian"},
{cat: "catalan"},
{ zho_sim: "chinese (simplified)" },
{ zho_tra: "chinese (traditional)" },
{ces: "czech"},
{dan: "danish"},
{deu: "german"},
{nld: "dutch"},
{ell: "greek"},
{en: "english"},
{est: "estonian"},
{fin: "finnish"},
{fra: "french"},
{fra_swi: "french (Switzerland)"},
{heb: "hebrew"},
{hrv: "croation"},
{hun: "hungarian"},
{ind: "indian"},
{ita: "italian"},
{kat: "georgian"},
{kaz: "kazakhstanian"},
{kor: "korean"},
{lav: "latvian"},
{lit: "lithuanian"},
{may: "malaysian"},
{nor: "norwegian"},
{pol: "polish"},
{por: "portuguese"},
{por_bra: "portuguese (Brazil)"},
{ron: "romanian"},
{rus: "russian"},
{slk: "slovak"},
{slv: "slovenian"},
{spa: "spanish"},
{spa_arg: "spanish (Argentina)"},
{srp: "serbian"},
{swe: "swedish"},
{tha: "thai"},
{tur: "turkish"},
{ukr: "ukrainian"},
{vie: "vietnamese"}
];

export const getLanguageList = () => {
  let list = [];
  languages.forEach(country => {
    const code = Object.keys(country)[0];
    list.push({
      id: code,
      name: country[code].charAt(0).toUpperCase() + country[code].slice(1),
    });
  });

  return list;
}